import { LTE_USAGE_BYTES, SECONDS } from '../constants/lteUsageBytes';

type LteUsageOperation = keyof typeof LTE_USAGE_BYTES;

export const getUsageTotalBytes = (operation: LteUsageOperation) => {
  const { payload, mqtt, tcp } = LTE_USAGE_BYTES[operation];

  return payload + mqtt + tcp;
};

export const calculateDataUsage = {
  serverConnection: (count: number) => {
    return count * (getUsageTotalBytes('TCP_CONNECT') + getUsageTotalBytes('MQTT_CONNECT'));
  },

  heartbeat: (count: number) => {
    return (SECONDS.MONTH / count) * getUsageTotalBytes('MQTT_HEARTBEAT');
  },

  dataCollection: (type: 'mfm' | 'custom', interval: number, count: number) => {
    const operation = type === 'mfm' ? 'PUBLISH_MFM' : 'PUBLISH_CUSTOM';
    if (type === 'mfm') {
      return (
        (SECONDS.MONTH / interval) *
        (count * LTE_USAGE_BYTES[operation].payload + LTE_USAGE_BYTES[operation].mqtt + LTE_USAGE_BYTES[operation].tcp)
      );
    }
    return (SECONDS.MONTH / interval) * (count * getUsageTotalBytes('PUBLISH_CUSTOM'));
  },

  arrayElement: (elementCount: number, arrayCount: number, interval: number) => {
    return (
      (SECONDS.MONTH / interval) *
      (elementCount * LTE_USAGE_BYTES['PUBLISH_MFM_ARRAY'].payload +
        arrayCount * (LTE_USAGE_BYTES['PUBLISH_MFM_ARRAY'].mqtt + LTE_USAGE_BYTES['PUBLISH_MFM_ARRAY'].tcp))
    );
  },

  alarm: (count: number) => {
    return count * getUsageTotalBytes('PUBLISH_ALARM');
  },
};
